module.exports = __webpack_public_path__ + "static/media/covid.00f4eb7c.svg";